import { render } from "./AdminSetting.vue?vue&type=template&id=4d0b5e48&scoped=true"
import script from "./AdminSetting.vue?vue&type=script&lang=js"
export * from "./AdminSetting.vue?vue&type=script&lang=js"

import "./AdminSetting.vue?vue&type=style&index=0&id=4d0b5e48&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d0b5e48"]])

export default __exports__